import React, { useEffect,useContext ,useState} from "react";
import { DropdownOption, Dropdown, Icon } from "@abb/abb-common-ux-react";
import getTimestamps from "../../util";
import { RootContext } from "../../contexts/root-context";
import filterJsonData from "./filters.json";
import { validateJson, isJsonValid } from '../../util';
import { useNavigate } from 'react-router-dom';
import "./filters.css";
function Filters() {
  const { setstartTS, endTS, setendTS } = useContext(RootContext);
  const navigate = useNavigate();

  const [monochrome, setMonochrome] = React.useState(false);
  const [selectedLocation, setSelectedLocation] = useState(" ");
  const [selectedSubstationID, setSelectedSubstationID] = useState(" "); 
    const handleIconClick = () => {
    navigate('/site-explorer'); // This will become: http://localhost:3000/#/site-explorer
  };

 const getLocation=(value)=>{
  setSelectedLocation(value)
 }

 const getSubstationID=(value)=>{
  setSelectedSubstationID(value)
 }

  const [selectedSingle, setSelectedSingle] = React.useState("Last 1 hour");
  const getFilterTime = (filterVal) => {
    setSelectedSingle(String(filterVal[0].label));
    setstartTS(getTimestamps(filterVal[0].value).startDate);
    setendTS(getTimestamps(filterVal[0].value).endDate);
  };

  const validateFilterData = () => {
    const jsonString = JSON.stringify(filterJsonData);

    if (isJsonValid(jsonString)) {
      validateJson(filterJsonData, filterJsonData.filterSchema);
    } else {
      console.error('Invalid JSON syntax: Missing braces or commas.');
    }
  };

  useEffect(() => {
    validateFilterData();
    
  }, [validateFilterData]);

  return (
    <>
      <div className="filter-row row filters" >
        <div className="col-5 col-m-12 col-s-12 fiter1bg">
          <div className="filter-header">{filterJsonData.title.value} <Icon sizeClass="small" name="abb/home" style={{ marginLeft: '20px' }}  onClick={handleIconClick}/></div>
        </div>
        <div className="col-7 col-m-12 col-s-12 flexcol1">
          <div className="filters-group row flexfilter">
            <Dropdown
              id={filterJsonData.dropdowns1[0].id}
              className="filter-dropdown col-s-12"
              label={filterJsonData.dropdowns1[0].label}
              placeholder={
                selectedSingle
                  ? selectedSingle
                  : filterJsonData.dropdowns1[0].placeholder
              }
              monochrome={monochrome}
              value={selectedSingle}
              onChange={getFilterTime}
            >
              {filterJsonData.dropdowns1[0].options
                .filter((o) => o.isEnabled)
                .map((o) => (
                  <DropdownOption
                    key={o.title}
                    label={o.title}
                    value={o.value}
                  />
                ))}
            </Dropdown>
            <Dropdown
              id={filterJsonData.dropdowns2[0].id}
              className="filter-dropdown col-s-12"
              label={filterJsonData.dropdowns2[0].label}
              placeholder={filterJsonData.dropdowns2[0].placeholder}
              monochrome={monochrome}
              value={selectedLocation}
              onChange={getLocation}
            >
              {filterJsonData.dropdowns2[0].options
                .filter((o) => o.isEnabled)
                .map((o) => (
                  <DropdownOption
                    key={o.title}
                    label={o.title}
                    value={o.value}
                  />
                ))}
            </Dropdown>
            <Dropdown
              id={filterJsonData.dropdowns3[0].id}
              className="filter-dropdown col-s-12"
              label={filterJsonData.dropdowns3[0].label}
              placeholder={filterJsonData.dropdowns3[0].placeholder}
              monochrome={monochrome}
              value={selectedSubstationID}
              onChange={getSubstationID}
            >
              {filterJsonData.dropdowns3[0].options
                .filter((o) => o.isEnabled)
                .map((o) => (
                  <DropdownOption
                    key={o.title}
                    label={o.title}
                    value={o.value}
                  />
                ))}
            </Dropdown>
          </div>
        </div>
      </div>
    </>
  );
}
export default Filters;
